import { InsuranceType, MainPath, publicPath } from "Constants/constants";

import { ADVICE_STEPS } from "Components/Features/CheckPrice/Products/Advice/adviceSteps";
import { AKA_CHILD_STEPS } from "Components/Features/CheckPrice/Products/LifeProducts/AkaChild/akaChildSteps";
import { CHILD_STEPS } from "Components/Features/CheckPrice/Products/LifeProducts/Child/childSteps";
import { PREGNANT_AND_NEWBORN_STEPS } from "Components/Features/CheckPrice/Products/LifeProducts/PregnantAndNewborn/pregnantAndNewbornSteps";
import { ACCIDENT_STEPS } from "Components/Features/CheckPrice/Products/RiskProducts/Accident/accidentSteps";
import { AKA_TRAVEL_STEPS } from "Components/Features/CheckPrice/Products/RiskProducts/AkaTravel/akaTravelSteps";
import { CABIN_STEPS } from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/Cabin/cabinSteps";
import { CABIN_CONTENTS_STEPS } from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/CabinContents/CabinContentsSteps";
import { HOUSE_STEPS } from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/House/houseSteps";
import { HOUSE_CONTENTS_STEPS } from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/HouseContents/houseContentsSteps";
import { HUSEIERNE_HOUSE_CONTENTS_STEPS } from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/HuseierneHouseContents/huseierneHouseContentsSteps";
import { TRAVEL_STEPS } from "Components/Features/CheckPrice/Products/RiskProducts/Travel/travelSteps";
import { VALUABLES_STEPS } from "Components/Features/CheckPrice/Products/RiskProducts/Valuables/valuablesConstants";
import { CAR_STEPS } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Car/carSteps";
import { CARAVAN_STEPS } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Caravan/caravanSteps";
import { MOPED_STEPS } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Moped/mopedSteps";
import { MOTORCYCLE_STEPS } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Motorcycle/motorcycleSteps";
import { TRACTOR_STEPS } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Tractor/tractorSteps";
import { TRAILER_STEPS } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Trailer/trailerSteps";
import { VETERAN_AUTO_STEPS } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/VeteranAuto/veteranAutoSteps";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";

export const rootUrl = (): string =>
  window.env.ENVIRONMENT === "development"
    ? `http://${window.location.host}/${publicPath}`
    : `https://${window.location.host}/${publicPath}`;

export const productsFromUrl = (): [string, InsuranceType][] =>
  Object.entries(InsuranceType).filter((entry) =>
    window.location.href.includes(`/${entry[1]}`),
  );

export const insuranceNameFromUrl = (
  url: string,
): INSURANCE_NAME_VALUE | undefined => {
  const inUrl = Object.entries(InsuranceType).filter((entry) => {
    return url.split("/").includes(entry[1]);
  });

  if (inUrl && inUrl.length > 0) {
    return insuranceTypeToInsuranceName(inUrl[0][1]);
  }
  return undefined;
};

export const productUri = (): string =>
  productsFromUrl()
    .map((entry) => entry[1])
    .reduce((_acc, cur) => cur);

export const firstStepUri = (): string =>
  productsFromUrl()
    .map((entry) => {
      const uri = firstStepUriFor(entry[1]);
      return uri ?? "";
    })
    .reduce((_acc, cur) => cur);

export const uriToCheckPriceStepFor = (insuranceType: InsuranceType): string =>
  `/${MainPath.CHECK_PRICE}/${insuranceType}/${firstStepUriFor(insuranceType)}`;

export function firstStepUriFor(product: InsuranceType): string | undefined {
  switch (product) {
    case InsuranceType.ACCIDENT:
      return ACCIDENT_STEPS[0].id;
    case InsuranceType.ADVICE:
      return ADVICE_STEPS[0].id;
    case InsuranceType.AKA_CHILD:
      return AKA_CHILD_STEPS[0].id;
    case InsuranceType.AKA_TRAVEL:
      return AKA_TRAVEL_STEPS[0].id;
    case InsuranceType.CABIN:
      return CABIN_STEPS[0].id;
    case InsuranceType.CABIN_CONTENTS:
      return CABIN_CONTENTS_STEPS[0].id;
    case InsuranceType.CAR:
      return CAR_STEPS[0].id;
    case InsuranceType.CARAVAN:
      return CARAVAN_STEPS[0].id;
    case InsuranceType.CHILD:
      return CHILD_STEPS[0].id;
    case InsuranceType.HOUSE:
      return HOUSE_STEPS[0].id;
    case InsuranceType.HOUSE_CONTENTS:
      return HOUSE_CONTENTS_STEPS[0].id;
    case InsuranceType.HUSEIERNE_HOUSE_CONTENTS:
      return HUSEIERNE_HOUSE_CONTENTS_STEPS[0].id;
    case InsuranceType.MOPED:
      return MOPED_STEPS[0].id;
    case InsuranceType.MOTORCYCLE:
      return MOTORCYCLE_STEPS[0].id;
    case InsuranceType.PREGNANT_AND_NEWBORN:
      return PREGNANT_AND_NEWBORN_STEPS[0].id;
    case InsuranceType.TRACTOR:
      return TRACTOR_STEPS[0].id;
    case InsuranceType.TRAILER:
      return TRAILER_STEPS[0].id;
    case InsuranceType.TRAVEL:
      return TRAVEL_STEPS[0].id;
    case InsuranceType.VALUABLE:
      return VALUABLES_STEPS[0].id;
    case InsuranceType.VETERAN_AUTO:
      return VETERAN_AUTO_STEPS[0].id;
  }
}

export const insuranceTypeToInsuranceName = (
  type: InsuranceType,
): INSURANCE_NAME_VALUE | undefined => {
  switch (type) {
    case InsuranceType.ADVICE:
      return INSURANCE_NAME_VALUE.ADVICE;
    case InsuranceType.AKA_CHILD:
      return INSURANCE_NAME_VALUE.AKA_CHILD;
    case InsuranceType.AKA_TRAVEL:
      return INSURANCE_NAME_VALUE.AKA_TRAVEL;
    case InsuranceType.ANIMAL:
      return INSURANCE_NAME_VALUE.ANIMAL;
    case InsuranceType.BOAT:
      return INSURANCE_NAME_VALUE.BOAT;
    case InsuranceType.CABIN:
      return INSURANCE_NAME_VALUE.CABIN;
    case InsuranceType.CABIN_CONTENTS:
      return INSURANCE_NAME_VALUE.CABIN_CONTENTS;
    case InsuranceType.CAR:
      return INSURANCE_NAME_VALUE.CAR;
    case InsuranceType.CARAVAN:
      return INSURANCE_NAME_VALUE.CARAVAN;
    case InsuranceType.CHILD:
      return INSURANCE_NAME_VALUE.CHILD;
    case InsuranceType.ELECTRIC_SCOOTER:
      return INSURANCE_NAME_VALUE.ELECTRIC_SCOOTER;
    case InsuranceType.HEALTH:
      return INSURANCE_NAME_VALUE.HEALTH;
    case InsuranceType.HOUSE:
      return INSURANCE_NAME_VALUE.HOUSE;
    case InsuranceType.HOUSE_CONTENTS:
      return INSURANCE_NAME_VALUE.HOUSE_CONTENTS;
    case InsuranceType.HUSEIERNE_HOUSE_CONTENTS:
      return INSURANCE_NAME_VALUE.HUSEIERNE_HOUSE_CONTENTS;
    case InsuranceType.MOPED:
      return INSURANCE_NAME_VALUE.MOPED;
    case InsuranceType.MOTORCYCLE:
      return INSURANCE_NAME_VALUE.MOTORCYCLE;
    case InsuranceType.PREGNANT_AND_NEWBORN:
      return INSURANCE_NAME_VALUE.PREGNANT_AND_NEWBORN;
    case InsuranceType.TRACTOR:
      return INSURANCE_NAME_VALUE.TRACTOR;
    case InsuranceType.TRAILER:
      return INSURANCE_NAME_VALUE.TRAILER;
    case InsuranceType.TRAVEL:
      return INSURANCE_NAME_VALUE.TRAVEL;
    case InsuranceType.VALUABLE:
      return INSURANCE_NAME_VALUE.VALUABLES;
    case InsuranceType.VETERAN_AUTO:
      return INSURANCE_NAME_VALUE.VETERAN_AUTO;
  }
};
